import {
  heroAcademicCap,
  heroBookOpen,
  heroChatBubbleLeftRight,
  heroCloud,
  heroCubeTransparent,
  heroSquare2Stack,
  heroUserGroup,
  heroWrenchScrewdriver,
} from '@ng-icons/heroicons/outline';

export interface ProductTypeOption {
  readonly key: string;
  readonly label: string;
  readonly icon: string;
  readonly description: string;
}

export const PRODUCT_TYPES: readonly ProductTypeOption[] = [
  {
    key: 'course',
    label: 'Curso / Treinamento',
    icon: 'heroAcademicCap',
    description: 'Aulas, conteúdos sequenciais, certificações.',
  },
  {
    key: 'service',
    label: 'Serviço',
    icon: 'heroWrenchScrewdriver',
    description: 'Consultoria, instalação, manutenção, atendimento.',
  },
  {
    key: 'physical',
    label: 'Produto Físico',
    icon: 'heroCubeTransparent',
    description: 'Bens tangíveis com entrega ou retirada.',
  },
  {
    key: 'saas',
    label: 'Assinatura SaaS',
    icon: 'heroCloud',
    description: 'Software por assinatura recorrente.',
  },
  {
    key: 'access',
    label: 'Acesso / Comunidade',
    icon: 'heroUserGroup',
    description: 'Membresia, grupos privados, áreas restritas.',
  },
  {
    key: 'mentoring',
    label: 'Mentoria',
    icon: 'heroChatBubbleLeftRight',
    description: 'Sessões 1-a-1, acompanhamento individual.',
  },
  {
    key: 'ebook',
    label: 'E-book / Material',
    icon: 'heroBookOpen',
    description: 'PDFs, planilhas, templates, downloads.',
  },
  {
    key: 'other',
    label: 'Outro',
    icon: 'heroSquare2Stack',
    description: 'Outra categoria não listada acima.',
  },
];

export const PRODUCT_TYPE_ICONS = {
  heroAcademicCap,
  heroBookOpen,
  heroChatBubbleLeftRight,
  heroCloud,
  heroCubeTransparent,
  heroSquare2Stack,
  heroUserGroup,
  heroWrenchScrewdriver,
} as const;

export function productTypeLabel(typeKey: string | null | undefined): string {
  if (!typeKey) return 'Sem tipo';
  return PRODUCT_TYPES.find((t) => t.key === typeKey)?.label ?? typeKey;
}

export function productTypeIcon(typeKey: string | null | undefined): string {
  if (!typeKey) return 'heroSquare2Stack';
  return PRODUCT_TYPES.find((t) => t.key === typeKey)?.icon ?? 'heroSquare2Stack';
}
